import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';

function Transition(props) {
    return <Slide direction="up" {...props} />;
}

class alertDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open:false
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps){
        if(nextProps.open !== this.state.open){
            this.setState({
                open: nextProps.open
            })
        }
    }

    handleClose = () => {
        this.setState({ open: false });
		if(this.props.closeFunction) this.props.closeFunction();
    };

    handleOK = () =>{
        this.setState({ open: false });
        if(this.props.okFunction) this.props.okFunction();
    };

    render() {
        const {title, text, cancelText, okText} = this.props;


        return (
            <Dialog
                open={this.state.open}
                TransitionComponent={Transition}
                keepMounted
                onClose={this.handleClose}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle id="alert-dialog-slide-title">
                    {title}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        {text}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleClose} color="primary">
                        {cancelText}
                    </Button>
                    <Button onClick={this.handleOK} color="primary">
                        {okText}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}
alertDialog.propTypes = {
    open:PropTypes.bool,
    title:PropTypes.string,
    text:PropTypes.object,
    cancelText : PropTypes.string,
    okText : PropTypes.string,
    okFunction:PropTypes.func,
	closeFunction:PropTypes.func

};
alertDialog.defaultProps = {
    open:false,
    cancelText : 'キャンセル',
    okText : 'OK',
};
export default alertDialog;



// WEBPACK FOOTER //
// ./src/common/components/dialog/alert-dialog.js